import label from "../../labels/interviewProcess_en.json";
import clabel from "../../../common/labels/common_en.json";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import ApprovalRuleEntity from "../cutOff/ApprovalCutOffEntity";
import TablePagination from "../../../common/components/TablePagination";
import Select from "react-select";
import dayjs from "dayjs";
import html2pdf from "html2pdf.js";
import {
  getAdminCategory,
  getAdminSubCategory,
  saveQualificationCutOff,
  getAllUnApproveCutOffListPagination,
  getAllUnApproveInterviewCriteriaListPagination,
  getAllUnApproveRecommendationCriteriaListPagination,
  SeatMatrixLockUnlock,
  getReservationData,
  getRecommendationCriteriaView,
} from "../../actions/interviewProcessActions";
import commonLabels from "../../../common/labels/common_en.json";
import {
  getAdvertisementsList,
  getExamslistByAdvertisementId,
  getObjectiveStatus,
  getObjectiveStatusflag,
  getPostCriteriaByAdvertisementId,
  getSubjectlistByExamId,
} from "../../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import {
  getYearList,
  getAdvertisementlistByYear,
  qualificationType,
  getqualificationType,
  getqualificationName,
  getqualificationNamebytype,
  getexperience,
  interviewRecommendation,
  recommendationCriteria,
  getInterviewCriteriaDataView,
  getRecommendationCriteriaDataView,
  getMainsAdvertisements,
} from "../../../common/actions/commonActions";
import { element } from "prop-types";
import ApprovalRecommendationCriteriaEntity from "./ApprovalRecommendationCriteriaEntity";
import {
  SET_MAINS_ADVERTISEMENT,
  SET_OBJECTIVE_STATUS_DATA,
  SET_OBJECTIVE_STATUS_DATA_FLAG,
  SET_RECOMMENDATION_REPORTS,
} from "../../../common/constants/ActionTypes";
import { useRef } from "react";
import { printrecommendationReport } from "../../../administration/actions/administrationActions";
import UpdateRecommendationCriteria from "./UpdateRecommendationCriteria";
import { toastr } from "react-redux-toastr";

const RecommendationCriteria = () => {
  const { register, handleSubmit, errors, reset } = useForm({
    mode: "onChange",
  });
  const pdfRef = useRef(null);
  let [selectedAdvertiseNo, setSelectedAdvertNo] = useState();
  let [selectedExam, setSelectedExam] = useState();
  let [selectedSubCategory, setSelectedSubCategory] = useState([]);
  const [selectedYear1, setSelectedYear1] = useState("");
  let [selectedAdvertiseNolist, setSelectedAdvertiseNolist] = useState();
  let [selectedExamlist, setSelectedExamlist] = useState();
  const [printFlag, setPrintFlag] = useState(true);
  let [requestedData, setRequestedData] = useState([]);
  const [stepName, setName] = useState("list");
  const [reloadItem, setReloadItem] = useState(true);
  let [listCurrentPage, setListCurrentPage] = useState(0);
  let [options, setOption] = useState([]);
  let [postCriteriaOptions, setPostCriteriaOptions] = useState([]);
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [confirmClicked, setConfirmClicked] = useState(false);
  const [selectedYear, setSelectedYear] = useState("");
  const [value, setValue] = useState([]);
  const [updatedValue, setUpdatedValue] = useState([]);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [selectedPostCriteria, setSelectedPostCriteria] = useState("");
  let [selectedApprovalEntity, setSelectedApprovalEntity] = useState("");
  const [qualificationCheckbox, setQualificationCheckbox] = useState([]);
  const [experienceCheckbox, setExperienceCheckbox] = useState([]);
  const [dobCheckbox, setDobCheckbox] = useState([]);
  let [selectedCategory, setSelectedCategory] = useState([]);
  const [lock, setUnlock] = useState(true);
  const [selectedCheckboxOrder, setSelectedCheckboxOrder] = useState([]);
  const [save, setSave] = useState(true);
  let [approvalEntityModal, setApprovalEntityModal] = useState(false);
  const [viewDisable, setViewDisable] = useState(true);
  const [flagArray, setFlagArray] = useState([]);
  const [showEdit, setShowEdit] = useState(false);
  const [showUnlock, setShowUnlock] = useState([]);
  const [additionalCriteria, setAdditionalCriteria] = useState([]);
  const [selectedStage, setSelectedStage] = useState("");
  const [recommendationSeatMatrixData, setRecommendationSeatMatrixData] = useState([]);
  const [addCriteria, setAddCriteria] = useState("NO");
  const [showTable, setShowTable] = useState(false);
  const session = JSON.parse(sessionStorage.getItem("session"));
  // const [expandedPost, setExpandedPost] = useState(null);


  const dispatch = useDispatch();
  let {
    adminCategoriesList,
    adminSubCategoriesList,
    getrecommendationCriterialist,
    getrecommendationCriteriaCounter,
    recommendationCriteriaView,
  } = useSelector((state) => state.interviewProcessReducer, shallowEqual);

  let {
    getqualificationtype,
    getqualificationName,
    getDesignation,
    getjobnature,
    getappointmentNature,
    getMainsAdvertisement,
    getRecommendationCriteriaData,
  } = useSelector((state) => state.common, shallowEqual);
  let tableCounter_unapproval = getrecommendationCriteriaCounter + 1;
  const handleApprovalUser = (ele) => {
    setSelectedApprovalEntity(ele);
    setApprovalEntityModal(true);
  };
  let {
    examList,
    advertisementList,
    postcriterialisting,
    objectiveStatusData,
    objectiveStatusDataFlag,
  } = useSelector((state) => state.postExamProcessObjectReducer, shallowEqual);

  let { yearList, allYearList } = useSelector(
    (state) => state.common,
    shallowEqual
  );

  let { listRecommendationReports } = useSelector(
    (state) => state.administrationReducer,
    shallowEqual
  );

  let unapprovalEntityHeader = [
    "Sr. No.",
    "Action",
    "Status",
    "Updated On",
    "Exam Name",
    "Entity Type",
    "Approval Type",
    "Approver",
    "Comments By Approver",
    "Action",
  ];

  let dobcheckedistrue = [
    { id: 1, name: "ascending" },
    { id: 2, name: "descending" },
  ];

  let rowPerPage = 10;
  const length = 50;

  useEffect(() => {
    setReloadItem(!reloadItem);
    window.scrollTo(0, 0);
    setSave(true);
    setPrintFlag(true);
    setViewDisable(true);
    setFlagArray([]);
    dispatch(getYearList());
    dispatch(getAdminCategory());
    dispatch(getAdminSubCategory());
    dispatch(getqualificationType());
    dispatch(getexperience("designation"));
    dispatch(getexperience("job_nature"));
    dispatch(getexperience("appointment_nature"));
    setReloadItem(!reloadItem);
  }, []);

  useEffect(() => {
    if (stepName == "unapproved") {
      dispatch(
        getAllUnApproveRecommendationCriteriaListPagination(
          listCurrentPage,
          rowPerPage
        )
      );
    }
    dispatch({
      payload: [],
      type: SET_OBJECTIVE_STATUS_DATA,
    });
    if (stepName == "list") {
      dispatch({
        payload: [],
        type: SET_OBJECTIVE_STATUS_DATA_FLAG,
      });
      dispatch({
        payload: [],
        type: SET_MAINS_ADVERTISEMENT,
      });
      flagArray.length = 0;
      setSelectedYear("");
      setRequestedData([]);
      setSelectedPostCriteria([]);
      setQualificationCheckbox([]);
      setExperienceCheckbox([]);
      setDobCheckbox([]);
      setSelectedCheckboxOrder([]);
    }
    if (stepName == "recommendationCriteriaList") {
      dispatch({
        type: SET_RECOMMENDATION_REPORTS,
        payload: [],
      });
      setPrintFlag(true);
      setViewDisable(true);
      setShowEdit(false);
      allYearList.length = 0;
      examList.length = 0;

      setSelectedAdvertiseNolist("");
      setSelectedExamlist("");
      setSelectedYear1("");
      setRequestedData([]);
      setSelectedPostCriteria([]);
      setQualificationCheckbox([]);
      setExperienceCheckbox([]);
      setDobCheckbox([]);
      setValue([]);
    }
  }, [stepName, listCurrentPage, rowPerPage]);

  useEffect(() => {
    if (recommendationCriteriaView?.postWiseCriteria?.length > 0) {
      setRecommendationSeatMatrixData(
        recommendationCriteriaView.postWiseCriteria
      );
      setShowTable(true);
    } else {
      setRecommendationSeatMatrixData([]);
      setShowTable(false);
    }
  }, [recommendationCriteriaView]);

  useEffect(() => {
    if (
      getRecommendationCriteriaData &&
      getRecommendationCriteriaData.length > 0
    ) {
      setUpdatedValue(getRecommendationCriteriaData);
    }
  });
  useEffect(() => {
    setOption(null);
    let optVal = [];
    adminSubCategoriesList &&
      adminSubCategoriesList.length > 0 &&
      adminSubCategoriesList.map((element, index) =>
        optVal.push({ value: element.id, label: element.name })
      );
    setOption(optVal);
  }, [adminSubCategoriesList]);

  useEffect(() => {
    setPostCriteriaOptions(null);
    if (postcriterialisting && postcriterialisting?.length >= 0) {
      const optionValue = postcriterialisting.map((element) => ({
        value: element.id,
        label: element.name,
      }));
      setPostCriteriaOptions(optionValue);
    }
  }, [postcriterialisting]);

  const onAdvertisementChange = (ele) => {
    setFlagArray([]);
    // setSelectedAdvertNo(ele);
    if (stepName == "list") {
      setSelectedAdvertNo(ele);
    } else if (stepName == "recommendationCriteriaList") {
      setSelectedAdvertiseNolist(ele);
      setViewDisable(true);
      dispatch({
        type: SET_RECOMMENDATION_REPORTS,
        payload: [],
      });
    }
    setSelectedExam("");
    setSaveButtonFlag(true);
    setConfirmClicked(false);
    setPrintFlag(true);
    setSave(true);
    examList.length = 0;
    ele && dispatch(getExamslistByAdvertisementId(ele));
    dispatch(getPostCriteriaByAdvertisementId(ele));
    setReloadItem(!reloadItem);
    setSelectedSubCategory("");
    setRequestedData([]);
    setSelectedPostCriteria([]);
    setQualificationCheckbox([]);
    setExperienceCheckbox([]);
    setDobCheckbox([]);
    setSelectedCheckboxOrder([]);
  };

  const onExamChange = (val) => {
    let selectedValue = val;
    Promise.resolve()
      .then(() => {
        if (stepName === "list") {
          setSelectedExam(selectedValue);


          return dispatch(getObjectiveStatusflag(selectedValue));
        } else if (stepName === "recommendationCriteriaList") {
          setSelectedExamlist(selectedValue);
          setViewDisable(false);
          setPrintFlag(true);


          return dispatch({
            type: SET_RECOMMENDATION_REPORTS,
            payload: [],
          });


        }
        return Promise.resolve();
      })
      .then(() => {
        setReloadItem((prev) => !prev);
        setRequestedData([]);
        setSave(true);
        setSelectedPostCriteria([]);
        setQualificationCheckbox([]);
        setExperienceCheckbox([]);
        setDobCheckbox([]);
        setSelectedCheckboxOrder([]);
      })
      .catch((error) => {
        console.error("Error during onExamChange:", error);
      });
  };
  const onPostCriteriaChange = (ele) => {
    setSelectedPostCriteria(ele);

    setReloadItem(!reloadItem);
  };

  const handleView = () => {
    if (!selectedExam) return;
    setShowTable(false);
    setRecommendationSeatMatrixData([]);
    dispatch(getRecommendationCriteriaView(selectedExam));
  };

  useEffect(() => {
    let tempReq = [];
    selectedPostCriteria &&
      selectedPostCriteria.length > 0 &&
      selectedPostCriteria.map((item, index) => {
        let isExist =
          requestedData &&
          requestedData.length > 0 &&
          requestedData.find((req) => req.postCriteriaId == item.value);

        if (isExist == undefined || isExist == "" || isExist == null) {
          let PostCriteria = {
            postCriteriaId: item.value,
          };

          setRequestedData((arr) => [...arr, PostCriteria]);
        } else {
          tempReq.push(isExist);
          setRequestedData(tempReq);
        }
      });
  }, [selectedPostCriteria]);

  useEffect(() => {
    setFlagArray([]);
    if (objectiveStatusDataFlag && objectiveStatusDataFlag.length > 0) {
      const nameWithFlagValues = objectiveStatusDataFlag.filter(
        (item) => item.flag === "Recommendation Criteria"
      );
      const flagValues = objectiveStatusDataFlag.map((item) => item.flag);
      setShowUnlock(nameWithFlagValues);
      const flagArrayBeforeInterviewCriteria = [];

      for (let i = 0; i < flagValues.length; i++) {
        if (flagValues[i] === "Recommendation Criteria") {
          setFlagArray(flagArrayBeforeInterviewCriteria);
          break;
        } else {
          if (objectiveStatusDataFlag[i]?.flagStatus) {
            flagArrayBeforeInterviewCriteria.push(
              objectiveStatusDataFlag[i]
            );
          }
        }
      }
      if (flagArrayBeforeInterviewCriteria.some(item => item.flagStatus === false)) {
        toastr.warning(label.UNLOCK_MESSAGE);
      }
    }
  }, [objectiveStatusDataFlag]);

  const onCategoryChange = (postID, val, innd) => {
    let tempCats = selectedCategory;

    if (tempCats.length === 0) {
      tempCats.push(val);
    } else {
      let isExist = false;
      tempCats = tempCats.map((selSubCat, index) => {
        if (innd === index) {
          isExist = true;
          return val;
        }
        return selSubCat;
      });

      if (!isExist) {
        tempCats.push(val);
      }
    }

    setSelectedCategory(tempCats);
    let leftData =
      selectedSubCategory &&
      selectedSubCategory.filter((subb, innnd) => innnd !== innd);
    setSelectedSubCategory(leftData);

    let tempVar = [];
    let tempReqData = requestedData;
    requestedData &&
      requestedData.length > 0 &&
      requestedData.map((reqData, ind) => {
        let tempCriteriaArr = [];
        if (reqData.postCriteriaId == postID) {
          if (reqData?.criteria && reqData?.criteria.length >= 0) {
            let isCat = reqData?.criteria.find(
              (catData) => catData.category == val
            );

            if (isCat === undefined || isCat === "" || isCat === null) {
              tempCriteriaArr = [
                ...reqData?.criteria,
                {
                  category: val,
                  subCategory: "",
                  reservedSeats: "",
                },
              ];

              const mergedObject = { ...reqData, criteria: tempCriteriaArr };
              tempReqData[ind] = mergedObject;

              setValue(`selectedSubCategory[${innd}].subCategory`, null);
            }
          } else {
            let newData = {
              criteria: [
                {
                  category: val,
                  subCategory: "",
                  reservedSeats: "",
                },
              ],
            };
            const mergedObject = { ...reqData, ...newData };
            tempReqData[ind] = mergedObject;

            setValue(`selectedSubCategory[${innd}].subCategory`, null);
          }

          setRequestedData(tempReqData);
        }
      });
    setSave(true);
    setReloadItem(!reloadItem);
  };

  const onSubCategoryChange = (postID, selectedValues, innd) => {
    let tempSubCats = [...selectedSubCategory];

    if (tempSubCats.length === 0) {
      tempSubCats.push(selectedValues);
    } else {
      let isExist = false;
      tempSubCats = tempSubCats.map((selSubCat, index) => {
        if (innd === index) {
          isExist = true;
          return selectedValues;
        }
        return selSubCat;
      });

      if (!isExist) {
        tempSubCats.push(selectedValues);
      }
    }
    setSelectedSubCategory(tempSubCats);

    let tempReqData = requestedData;

    tempReqData &&
      tempReqData.length > 0 &&
      tempReqData.forEach((reqData, ind) => {
        if (reqData.postCriteriaId === postID) {
          let selectedCategoryLabel = selectedValues[0]?.label;

          if (reqData.criteria[0]?.category !== selectedCategoryLabel) {
            setValue(`selectedSubCategory[${innd}].subCategory`, null);
          }

          let catVal = selectedCategory[innd];

          // Check if any subcategory is deselected
          if (!selectedValues.length) {
            // Remove the criteria with the matching category
            tempReqData[ind].criteria = tempReqData[ind].criteria.filter(
              (item) => item.category !== catVal
            );
          } else {
            let tempCriteriaArr = [];

            selectedValues.forEach((subCat) => {
              let findDuplicatedata = reqData.criteria.find(
                (item) =>
                  item.category === catVal && item.subCategory === subCat.label
              );
              if (findDuplicatedata === undefined) {
                let criteriaData = {
                  category: catVal,
                  subCategory: subCat.label,
                  reservedSeats: "",
                };
                tempCriteriaArr.push(criteriaData);
              }
            });

            let isNotExist = reqData.criteria.find(
              (itm) =>
                (itm.category === catVal && itm.subCategory !== "") ||
                itm.subCategory === ""
            );

            if (!isNotExist) {
              let mergeData = [
                ...tempReqData[ind].criteria,
                ...tempCriteriaArr,
              ];
              tempReqData[ind].criteria = mergeData;
            } else {
              tempReqData[ind].criteria = [
                ...tempReqData[ind].criteria,
                ...tempCriteriaArr,
              ];

              tempReqData[ind].criteria = tempReqData[ind].criteria.filter(
                (item) => item.subCategory !== ""
              );
            }
          }
        }
      });

    setRequestedData(tempReqData);
    setSave(true);
    setReloadItem(!reloadItem);
  };

  const onSelectYear = (ele) => {
    setFlagArray([]);
    if (ele == "") {
      onCancelButton();
    } else {
      let selectedValue = ele;
      if (stepName == "list") {
        setSelectedYear(selectedValue);
      } else if (stepName == "recommendationCriteriaList") {
        setSelectedYear1(selectedValue);
        setViewDisable(true);
        dispatch({
          type: SET_RECOMMENDATION_REPORTS,
          payload: [],
        });
      }
      selectedValue && dispatch(getMainsAdvertisements(selectedValue));
      if (getMainsAdvertisement) {
        getMainsAdvertisement.length = 0;
      }
      if (examList) {
        examList.length = 0;
      }
      setSave(true);
      setSelectedSubCategory("");
      setSaveButtonFlag(true);
      setRequestedData([]);
      setSelectedPostCriteria([]);
      setQualificationCheckbox([]);
      setExperienceCheckbox([]);
      setDobCheckbox([]);
      setSelectedCheckboxOrder([]);
      setReloadItem(!reloadItem);
    }
  };

  const onhandledobcheckbox = (postID, selectedValues, innd) => {
    let selected = selectedValues;
    let dobLen = dobCheckbox.length;
    let tempReqData = [...requestedData];
    let priority = selectedCheckboxOrder.length + 1;
    if (dobLen < innd) {
      let temp = [];
      for (let i = 0; i <= innd; i++) {
        if (i === innd) {
          temp.push(selected);
        } else {
          temp.push(dobCheckbox[i]);
        }
      }
      setDobCheckbox(temp);
    } else {
      let temp = dobCheckbox;
      temp[innd] = selected;
      setDobCheckbox(temp);
    }
    tempReqData.forEach((reqData, ind) => {
      if (reqData.postCriteriaId === postID) {
        const dobIndex = selectedCheckboxOrder.indexOf("dob");
        if (reqData?.dob && selected === false) {
          setSelectedCheckboxOrder((prevOrder) =>
            prevOrder.filter((type) => type !== "dob")
          );
          tempReqData[ind].dob = "";
          if (dobIndex !== -1 && tempReqData[ind].dob) {
            tempReqData[ind].dob.priority = dobIndex + 1;
          }
        } else if (selected === true) {
          let dob = {
            dob: {
              type: "dob",
              flgConsider: selected,
              priority: priority++,
              order: "",
            },
          };
          const mergedObject = { ...reqData, ...dob };
          tempReqData[ind] = mergedObject;
          if (dobIndex === -1) {
            tempReqData.forEach((item, index) => {
              if (selectedCheckboxOrder.includes("dob") && item.dob) {
                item.dob.priority = index + 1;
              }
            });
          } else if (tempReqData[ind].dob) {
            tempReqData[ind].dob.priority = dobIndex + 1;
          }
          setSelectedCheckboxOrder((prevOrder) => [...prevOrder, "dob"]);
        }
      }
    });

    setRequestedData(tempReqData);
    // setSave(false);
  };

  const onhandlequalificationcheckbox = (postID, selectedValues, innd) => {
    let selected = selectedValues;
    let quaLen = qualificationCheckbox.length;

    let tempReqData = [...requestedData];
    let priority = selectedCheckboxOrder.length + 1;

    if (quaLen < innd) {
      let temp = [];
      for (let i = 0; i <= innd; i++) {
        if (i === innd) {
          temp.push(selected);
        } else {
          temp.push(qualificationCheckbox[i]);
        }
      }
      setQualificationCheckbox(temp);
    } else {
      let temp = qualificationCheckbox;
      temp[innd] = selected;
      setQualificationCheckbox(temp);
    }

    tempReqData.forEach((reqData, ind) => {
      if (reqData.postCriteriaId === postID) {
        const qualificationIndex =
          selectedCheckboxOrder.indexOf("qualification");
        if (reqData?.qualification && selected == false) {
          setSelectedCheckboxOrder((prevOrder) =>
            prevOrder.filter((type) => type !== "qualification")
          );
          tempReqData[ind].qualification = "";
          if (qualificationIndex !== -1 && tempReqData[ind].qualification) {
            tempReqData[ind].qualification.priority = qualificationIndex + 1;
          }
        } else {
          let qualification = {
            qualification: {
              type: "qualification",
              flgConsider: selected,
              priority: priority++,
              data: [],
            },
          };
          const mergedObject = { ...reqData, ...qualification };
          tempReqData[ind] = mergedObject;
          if (qualificationIndex === -1) {
            tempReqData.forEach((item, index) => {
              if (
                selectedCheckboxOrder.includes("qualification") &&
                item.qualification
              ) {
                item.qualification.priority = index + 1;
              }
            });
          } else if (tempReqData[ind].qualification) {
            tempReqData[ind].qualification.priority = qualificationIndex + 1;
          }
          setSelectedCheckboxOrder((prevOrder) => [
            ...prevOrder,
            "qualification",
          ]);
        }
      }
    });
    setRequestedData(tempReqData);
    setSave(false);
  };

  const onhandleexperiencecheckbox = (postID, selectedValues, innd) => {
    let selected = selectedValues;
    let expLen = experienceCheckbox.length;

    let tempReqData = [...requestedData];
    let priority = selectedCheckboxOrder.length + 1;

    if (expLen < innd) {
      let temp = [];
      for (let i = 0; i <= innd; i++) {
        if (i === innd) {
          temp.push(selected);
        } else {
          temp.push(experienceCheckbox[i]);
        }
      }
      setExperienceCheckbox(temp);
    } else {
      let temp = experienceCheckbox;
      temp[innd] = selected;
      setExperienceCheckbox(temp);
    }

    tempReqData.forEach((reqData, ind) => {
      if (reqData.postCriteriaId === postID) {
        const experienceIndex = selectedCheckboxOrder.indexOf("experience");
        if (reqData?.experience && selected === false) {
          setSelectedCheckboxOrder((prevOrder) =>
            prevOrder.filter((type) => type !== "experience")
          );
          tempReqData[ind].experience = "";
          if (experienceIndex !== -1 && tempReqData[ind].experience) {
            tempReqData[ind].experience.priority = experienceIndex + 1;
          }
        } else {
          let experience = {
            experience: {
              type: "experience",
              flgConsider: selected,
              priority: priority++,
              data: [],
            },
          };
          const mergedObject = { ...reqData, ...experience };
          tempReqData[ind] = mergedObject;
          if (experienceIndex === -1) {
            tempReqData.forEach((item, index) => {
              if (
                selectedCheckboxOrder.includes("experience") &&
                item.experience
              ) {
                item.experience.priority = index + 1;
              }
            });
          } else if (tempReqData[ind].experience) {
            tempReqData[ind].experience.priority = experienceIndex + 1;
          }
          setSelectedCheckboxOrder((prevOrder) => [...prevOrder, "experience"]);
        }
      }
    });

    setRequestedData(tempReqData);
    // setSave(false);
  };

  // const onhandledobcheckbox = (postID, selectedValues, innd) => {
  //   let selected = selectedValues;
  //   let dobLen = dobCheckbox.length;
  //   if (dobLen < innd) {
  //     let temp = [];
  //     for (let i = 0; i <= innd; i++) {
  //       if (i == innd) {
  //         temp.push(selected);
  //       } else {
  //         temp.push(dobCheckbox[i]);
  //       }
  //     }
  //     setDobCheckbox(temp);
  //   } else {
  //     let temp = dobCheckbox;
  //     temp[innd] = selected;
  //     setDobCheckbox(temp);
  //   }

  //   let tempReqData = [...requestedData];
  //   tempReqData.forEach((reqData, ind) => {
  //     if (reqData.postCriteriaId === postID) {
  //       if (reqData?.dob && selected == false) {
  //         tempReqData[ind].dob = "";
  //       } else {
  //         let dob = {
  //           dob: {
  //             type: "dob",
  //             flgConsider: selected,
  //             priority: 0,
  //             order: "",
  //           },
  //         };
  //         const mergedObject = { ...reqData, ...dob };
  //         tempReqData[ind] = mergedObject;
  //       }
  //     }
  //   });
  //   setRequestedData(tempReqData);

  //   // if (dataArray.length > 0 && selected) {
  //   //   const dobData = {
  //   //     type: "dob",
  //   //     flgConsider: selected,
  //   //     priority: dataArray.length + 1,
  //   //     order: selectOrder,
  //   //   };
  //   //   setDataArray((arr) => [...arr, dobData]);
  //   // }
  // };
  // const onhandlequalificationcheckbox = (postID, selectedValues, innd) => {
  //   let selected = selectedValues;
  //   let quaLen = qualificationCheckbox.length;
  //   if (quaLen < innd) {
  //     let temp = [];
  //     for (let i = 0; i <= innd; i++) {
  //       if (i == innd) {
  //         temp.push(selected);
  //       } else {
  //         temp.push(qualificationCheckbox[i]);
  //       }
  //     }

  //     setQualificationCheckbox(temp);
  //   } else {
  //     let temp = qualificationCheckbox;
  //     temp[innd] = selected;
  //     setQualificationCheckbox(temp);
  //   }

  //   let tempReqData = [...requestedData];
  //   tempReqData.forEach((reqData, ind) => {
  //     if (reqData.postCriteriaId === postID) {
  //       if (reqData?.qualification && selected == false) {
  //         tempReqData[ind].qualification = "";
  //       } else {
  //         let qualification = {
  //           qualification: {
  //             type: "qualification",
  //             flgConsider: selected,
  //             priority: 0,
  //             qualificationtypecode: "",
  //             qualificationnamecode: "",
  //           },
  //         };
  //         const mergedObject = { ...reqData, ...qualification };
  //         tempReqData[ind] = mergedObject;
  //       }
  //     }
  //   });
  //   setRequestedData(tempReqData);
  // };

  // const onhandleexperiencecheckbox = (postID, selectedValues, innd) => {
  //   let selected = selectedValues;
  //   let quaLen = experienceCheckbox.length;
  //   if (quaLen < innd) {
  //     let temp = [];
  //     for (let i = 0; i <= innd; i++) {
  //       if (i == innd) {
  //         temp.push(selected);
  //       } else {
  //         temp.push(experienceCheckbox[i]);
  //       }
  //     }

  //     setExperienceCheckbox(temp);
  //   } else {
  //     let temp = experienceCheckbox;
  //     temp[innd] = selected;
  //     setExperienceCheckbox(temp);
  //   }

  //   let tempReqData = [...requestedData];
  //   tempReqData.forEach((reqData, ind) => {
  //     if (reqData.postCriteriaId === postID) {
  //       if (reqData?.experience && selected == false) {
  //         tempReqData[ind].experience = "";
  //       } else {
  //         let experience = {
  //           experience: {
  //             type: "experience",
  //             flgConsider: selected,
  //             priority: 0,
  //             typeEmploymentLookupId: "",
  //             designation: "",
  //             jobNatureLookupId: "",
  //           },
  //         };
  //         const mergedObject = { ...reqData, ...experience };
  //         tempReqData[ind] = mergedObject;
  //       }
  //     }
  //   });
  //   setRequestedData(tempReqData);
  // };

  const ondobOrder = (postID, selectedValues, innd) => {
    let selected = selectedValues;

    let tempReqData = [...requestedData];
    tempReqData &&
      tempReqData.length > 0 &&
      tempReqData.map((reqData, ind) => {
        if (reqData.postCriteriaId === postID) {
          if (reqData?.dob) {
            tempReqData[ind].dob.order = selected;
          } else {
            let dob = {
              dob: {
                type: "dob",
                flgConsider: dobCheckbox[innd],
                priority: 1,
                order: selected,
              },
            };
            const mergedObject = { ...reqData, ...dob };
            tempReqData[ind] = mergedObject;
          }
        }
      });
    setRequestedData([...tempReqData]);
    // const temp = [...dataArray];
    // temp.forEach((item, index) => {
    //   if (item.type === "dob") {
    //     temp[index].order = selected;
    //   }
    // });

    // setDataArray(temp);
  };

  const onQualificationType = (postID, selectedValues, innd) => {
    // Check if the selected qualification type already exists
    const qualificationExists = requestedData.some((reqData) => {
      return (
        reqData.postCriteriaId === postID &&
        reqData.qualification &&
        reqData.qualification.data &&
        reqData.qualification.data.some(
          (data) => data.qualificationtypecode === selectedValues
        )
      );
    });

    if (!qualificationExists) {
      let selected = selectedValues;

      let tempReqData = [...requestedData];
      tempReqData.forEach((reqData, ind) => {
        if (reqData.postCriteriaId === postID) {
          getqualificationName.length = 0;
          reqData.qualification = reqData.qualification || {
            type: "experience",
            flgConsider: true,
            priority: 1,
            data: [],
          };
          reqData.qualification.data.push({
            priority: reqData.qualification.data.length + 1,
            qualificationtypecode: selectedValues,
            qualificationnamecode: "",
          });
        }
        return reqData;
      });
      setRequestedData(tempReqData);
      selected && dispatch(getqualificationNamebytype(selected));
    }
  };

  const onQualificationName = (postID, selectedValues, innd) => {
    let tempReqData = [...requestedData];
    tempReqData.forEach((reqData, ind) => {
      if (reqData.postCriteriaId === postID) {
        reqData.qualification.data[
          reqData.qualification.data.length - 1
        ].qualificationnamecode = selectedValues;
      }
    });
    setRequestedData(tempReqData);
  };

  const onCancelButton = () => {
    if (stepName == "list") {
      reset();
    }
    if (stepName == "recommendationCriteriaList") {
      reset();
      dispatch({
        type: SET_RECOMMENDATION_REPORTS,
        payload: [],
      });
      setViewDisable(true);
    }
    dispatch({
      payload: [],
      type: SET_OBJECTIVE_STATUS_DATA_FLAG,
    });
    flagArray.length = 0;
    setSelectedSubCategory("");
    setSelectedYear("");
    setRequestedData([]);
    setSelectedPostCriteria("");
    setPostCriteriaOptions("");
    allYearList.length = 0;
    examList.length = 0;
    setShowTable(false);
    setRecommendationSeatMatrixData([]);
    // postcriterialisting.length = 0;
    setReloadItem(!reloadItem);
  };

  // const onhandleexperiencecheckbox = (postID, selectedValues, innd) => {
  //   let selected = selectedValues;
  //   let expLen = experienceCheckbox.length;

  //   let tempReqData = [...requestedData];
  //   let priority = selectedCheckboxOrder.length + 1;

  //   if (expLen < innd) {
  //     let temp = [];
  //     for (let i = 0; i <= innd; i++) {
  //       if (i === innd) {
  //         temp.push(selected);
  //       } else {
  //         temp.push(experienceCheckbox[i]);
  //       }
  //     }
  //     setExperienceCheckbox(temp);
  //   } else {
  //     let temp = experienceCheckbox;
  //     temp[innd] = selected;
  //     setExperienceCheckbox(temp);
  //   }

  //   tempReqData.forEach((reqData, ind) => {
  //     if (reqData.postCriteriaId === postID) {
  //       const experienceIndex = selectedCheckboxOrder.indexOf("experience");
  //       if (reqData?.experience && selected === false) {
  //         setSelectedCheckboxOrder((prevOrder) =>
  //           prevOrder.filter((type) => type !== "experience")
  //         );
  //         tempReqData[ind].experience = "";
  //         if (experienceIndex !== -1 && tempReqData[ind].experience) {
  //           tempReqData[ind].experience.priority = experienceIndex + 1;
  //         }
  //       } else {
  //         let experience = {
  //           experience: {
  //             type: "experience",
  //             flgConsider: selected,
  //             priority: priority++,
  //             data: [],
  //           },
  //         };
  //         const mergedObject = { ...reqData, ...experience };
  //         tempReqData[ind] = mergedObject;
  //         if (experienceIndex === -1) {
  //           tempReqData.forEach((item, index) => {
  //             if (
  //               selectedCheckboxOrder.includes("experience") &&
  //               item.experience
  //             ) {
  //               item.experience.priority = index + 1;
  //             }
  //           });
  //         } else if (tempReqData[ind].experience) {
  //           tempReqData[ind].experience.priority = experienceIndex + 1;
  //         }
  //         setSelectedCheckboxOrder((prevOrder) => [...prevOrder, "experience"]);
  //       }
  //     }
  //   });

  //   setRequestedData(tempReqData);
  //   setSave(false);
  // };

  const onDesignation = (postID, selectedValue, index) => {
    // Check if the selected designation already exists in the requestData
    const designationExists = requestedData.some((reqData) => {
      return (
        reqData.postCriteriaId === postID &&
        reqData.experience &&
        reqData.experience.data &&
        reqData.experience.data.some(
          (data) => data.designation === selectedValue
        )
      );
    });

    if (!designationExists) {
      const tempReqData = requestedData.map((reqData) => {
        if (reqData.postCriteriaId === postID) {
          reqData.experience = reqData.experience || {
            type: "experience",
            flgConsider: true,
            priority: 1,
            data: [],
          };
          reqData.experience.data.push({
            priority: reqData.experience.data.length + 1,
            designation: selectedValue,
            typeEmploymentLookupId: 0,
            jobNatureLookupId: 0,
          });
        }
        return reqData;
      });

      setRequestedData(tempReqData);
    }
  };

  const onJobNature = (postID, selectedValue, index) => {
    const tempReqData = requestedData.map((reqData) => {
      if (
        reqData.postCriteriaId === postID &&
        reqData.experience.data.length > 0
      ) {
        reqData.experience.data[
          reqData.experience.data.length - 1
        ].jobNatureLookupId = selectedValue;
      }
      return reqData; // Return reqData for each iteration
    });

    setRequestedData(tempReqData);
  };

  const onAppointmentNature = (postID, selectedValue, index) => {
    const tempReqData = requestedData.map((reqData) => {
      if (
        reqData?.postCriteriaId === postID &&
        reqData.experience.data.length > 0
      ) {
        reqData.experience.data[
          reqData.experience.data.length - 1
        ].typeEmploymentLookupId = selectedValue;
      }
      return reqData; // Return reqData for each iteration
    });

    setRequestedData(tempReqData);
  };

  useEffect(() => {
    if (requestedData && requestedData.length > 0) {
      if (
        additionalCriteria.length > 0 &&
        additionalCriteria.every(item => item === "NO")
      ) {
        setSave(false);
        return;
      }
      requestedData.every((item) => {
        item.criteria &&
          item.criteria.length > 0 &&
          item.criteria.every((item) => {
            if (item.category === "") {
              setSave(true);
              setReloadItem(!reloadItem);
            } else if (item.subCategory === "") {
              setSave(true);
              setReloadItem(!reloadItem);
            } else if (item.reservedSeat === "") {
              setSave(true);
              setReloadItem(!reloadItem);
            }
          });
        if (
          item.experience &&
          item.experience.data &&
          item.experience.data.length == 0
        ) {
          setSave(true);
          setReloadItem(!reloadItem);
        } else if (
          item.experience &&
          item.experience.data &&
          item.experience.data.length > 0
        ) {
          item.experience.data.every((expItem) => {
            if (expItem.designation === "" || expItem.designation === 0) {
              setSave(true);
              setReloadItem(!reloadItem);
            } else if (
              expItem.typeEmploymentLookupId === "" ||
              expItem.typeEmploymentLookupId === 0
            ) {
              setSave(true);
              setReloadItem(!reloadItem);
            } else if (
              expItem.jobNatureLookupId === "" ||
              expItem.jobNatureLookupId === 0
            ) {
              setSave(true);
              setReloadItem(!reloadItem);
            } else {
              setSave(false);
              setReloadItem(!reloadItem);
            }
          });
        } else if (
          item.qualification &&
          item?.qualification?.data &&
          item?.qualification?.data.length == 0
        ) {
          setSave(true);
          setReloadItem(!reloadItem);
        } else if (
          item.qualification &&
          item.qualification.data &&
          item.qualification.data.length > 0
        ) {
          item.qualification.data.every((expItem) => {
            if (
              expItem.qualificationtypecode === "" ||
              expItem.qualificationtypecode === 0
            ) {
              setSave(true);
              setReloadItem(!reloadItem);
            } else if (
              expItem.qualificationnamecode === "" ||
              expItem.qualificationnamecode === 0
            ) {
              setSave(true);
              setReloadItem(!reloadItem);
            } else {
              setSave(false);
              setReloadItem(!reloadItem);
            }
          });
        } else if (item.dob && item.dob.type === "dob") {
          if (item.dob.order !== "") {
            setSave(false);
            setReloadItem(!reloadItem);
          } else {
            setSave(true);
            setReloadItem(!reloadItem);
          }
        } else {
          setSave(false);
        }
      });
    }
  }, [requestedData]);

  const onSubmit = (e) => {
    // let newData = requestedData;
    // let newData1 = [];

    // requestedData &&
    //   requestedData.length > 0 &&
    //   requestedData.map((ele, ind) => {
    //     let issExist =
    //       selectedSubCategory &&
    //       selectedSubCategory.length > 0 &&
    //       selectedSubCategory.find(
    //         (subCont) => subCont.label == ele.subCategory
    //       );

    //     if (issExist == undefined) {
    //       newData1 =
    //         newData &&
    //         newData.length > 0 &&
    //         newData.filter((elle) => elle.subCategory != ele.subCategory);
    //       newData = newData1;
    //     }
    //   });

    // const dob = dataArray.filter((item) => item.type == "dob");
    // const dataobject1 = dob.reduce((acc, current, index) => {
    //   acc[index] = current;
    //   return acc;
    // }, {});

    // const qualification = dataArray.filter(
    //   (item) => item.type == "qualification"
    // );
    // const dataobject2 = qualification.reduce((acc, current, index) => {
    //   acc[index] = current;
    //   return acc;
    // }, {});

    // const experience = dataArray.filter((item) => item.type == "experience");
    // const dataobject3 = experience.reduce((acc, current, index) => {
    //   acc[index] = current;
    //   return acc;
    // }, {});

    // const arrayData = [];
    if (stepName === "list") {
      const data = requestedData;
      const dataEntry = data.map((item) => {
        const { dob, qualification, experience, ...rest } = item;

        if (dob === "" && qualification === "" && experience === "") {
          return rest;
        } else if (dob === "" && qualification !== "" && experience !== "") {
          return { qualification, experience, ...rest };
        } else if (dob === "" && qualification === "" && experience !== "") {
          return { experience, ...rest };
        } else if (dob === "" && qualification !== "" && experience === "") {
          return { qualification, ...rest };
        } else if (dob !== "" && qualification === "" && experience === "") {
          return { dob, ...rest };
        } else if (dob !== "" && qualification === "" && experience !== "") {
          return { dob, experience, ...rest };
        } else if (dob !== "" && qualification !== "" && experience === "") {
          return { dob, qualification, ...rest };
        } else {
          return item;
        }
      });

      setUnlock(false);
      // {
      //   dob:dataobject1[0],
      //   experience:dataobject3[0],
      //   qualification:dataobject2[0]
      // }
      if (selectedYear !== "" && selectedAdvertiseNo !== "" && selectedExam !== "" || selectedPostCriteria.length !== 0) {
        dispatch(recommendationCriteria(selectedExam, dataEntry, setSave));
      } else {
        toastr.error("Please fill required fields")
      }
      onCancelButton();
    }
  };

  const handleLockUnlock = (status, lock) => {
    selectedExam &&
      dispatch(SeatMatrixLockUnlock(selectedExam, status, lock, setUnlock));
    dispatch(getObjectiveStatus(selectedExam));
    dispatch(getObjectiveStatusflag(selectedExam));
  };

  const onReserveSeatChange = (postID, val, subCat) => {
    // Create a new copy of requestedData
    let tempReq = [...requestedData];

    // Iterate through the copied array
    tempReq.forEach((data, ind) => {
      if (data.postCriteriaId == postID) {
        if (data.criteria && data.criteria.length > 0) {
          data.criteria.forEach((criData, innd) => {
            if (
              criData.subCategory == subCat &&
              criData.category == selectedCategory[0]
            ) {
              // Update the reservedSeats value for the matching criteria
              tempReq[ind].criteria[innd].reservedSeats = val;
            }
          });
        }
      }
    });

    // Update the state with the modified copy of requestedData
    setRequestedData(tempReq);
    setSave(false);
  };

  const onViewButton = (type) => {
    setShowEdit(true);
    dispatch(printrecommendationReport(selectedExamlist, type, setPrintFlag));
  };

  const downloadPdf = () => {
    genPdf();
    setSaveButtonFlag(true);
    setReloadItem(!reloadItem);
  };

  const genPdf = () => {
    let headerDiv =
      '<div class="row d-flex flex-column align-items-center"><h5>' +
      commonLabels.MPSC +
      "</h5><h5>" +
      listRecommendationReports.advertisementName +
      "</h5></div>";
    const htmlContent = document.createElement("div");
    // htmlContent.innerHTML = headerDiv;
    htmlContent.innerHTML += pdfRef.current.innerHTML;
    htmlContent.style.fontSize = "10px";
    const options = {
      margin: [0.9, 0.4, 0.4, 0.4],
      filename: "Recommendation_Criteria.pdf",
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 3, dpi: 300, letterRendering: true },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
        compressPDF: true,
      },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth =
            (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;

          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .split("/")
            .join("/");
          const dateWidth =
            (pdf.getStringUnitWidth(formattedDate) *
              pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          let dateX = pageWidth - dateWidth;
          if (i !== 1) {
            dateX = pageWidth - dateWidth - 0.4;
          }
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, dateX, textY);

          const ad = listRecommendationReports.advertisementNo;
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);

          const headerText1 = label.MPSC;
          const headerX1 = pdf.internal.pageSize.width / 2;
          const headerY1 = 0.6;

          pdf.setFontSize(10);
          pdf.text(headerText1, headerX1, headerY1, { align: "center" });

          const headerText2 = listRecommendationReports.examName;
          const headerX2 = pdf.internal.pageSize.width / 2;
          const headerY2 = 0.8;

          pdf.setFontSize(10);
          pdf.text(headerText2, headerX2, headerY2, { align: "center" });
        }

        pdf.save(`Recommendation_Criteria.pdf`);
      });
  };

  const onEditButton = () => {
    setShowUpdateModal(true);
    dispatch(getRecommendationCriteriaDataView(selectedExamlist));
  };

  const handlePostCriteria = (selectedOptions) => {
    setSelectedPostCriteria(selectedOptions);
    const selectedIds = selectedOptions.map((option) => option.value);
    const updatedData = requestedData.filter((item) =>
      selectedIds.includes(item.postCriteriaId)
    );
    setRequestedData(updatedData);
  };
  return (
    <div className="dashboardContentArea">
      <h5 className="labelMargin"> {label.RecommendationCriteria} </h5>
      <div
        className="tab-content border border-light myTabContent"
        id="myTabContentContainer"
      >
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" key="0">
            <a
              href="#"
              className={
                stepName === "list"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="list"
              id="list-tab"
              onClick={() => setName("list")}
              data-toggle="tab"
              role="tab"
              aria-controls="list"
              aria-selected="false"
            >
              <span>{label.RecommendationCriteria}</span>
            </a>
          </li>
          <li className="nav-item" key="1">
            <a
              href="#"
              className={
                stepName === "unapproved"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="unapproved"
              id="unapproved-tab"
              onClick={() => setName("unapproved")}
              data-toggle="tab"
              role="tab"
              aria-controls="unapproved"
              aria-selected="false"
            >
              <span>{label.UnapprovedRecommendationCriteriaList}</span>
            </a>
          </li>
          <li className="nav-item" key="1">
            <a
              href="#"
              className={
                stepName === "recommendationCriteriaList"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="recommendationCriteriaList"
              id="recommendationCriteriaList-tab"
              onClick={() => setName("recommendationCriteriaList")}
              data-toggle="tab"
              role="tab"
              aria-controls="recommendationCriteriaList"
              aria-selected="false"
            >
              <span>{label.recommendationCriteriaList}</span>
            </a>
          </li>
        </ul>
        <div className="tab-content border border-light" id="myTabContent">
          <div
            className={
              stepName === "list"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="list"
            role="tabpanel"
            aria-labelledby="list-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <form name="importForm" encType="multipart/form-data">
                  <div className="form-group ">
                    <div className="row">
                      <div className="form-group col-md-2">
                        <label className="float-left">
                          {commonLabels.selectYear}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedYear"
                          value={selectedYear}
                          // ref={register({ required: true })}
                          onChange={(e) => {
                            onSelectYear(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {yearList &&
                            yearList.length > 0 &&
                            yearList.map((element, index) => (
                              <option>{element}</option>
                              // <option key={index} value={element.id}>
                              //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                              // </option>
                            ))}
                        </select>
                        {_.get("selectedYear.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>
                      <div className="form-group col-md-4">
                        <label className="float-left">
                          {commonLabels.SelectAdvertNo}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedAdvertiseNo"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onAdvertisementChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {getMainsAdvertisement &&
                            getMainsAdvertisement.length > 0 &&
                            getMainsAdvertisement
                              .filter(
                                (element) =>
                                  element.isDeleted == false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedAdvertiseNo.type", errors) ===
                          "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                      </div>
                      <div className="form-group col-md-3">
                        <label className="float-left">
                          {label.SelectExam}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedExam"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onExamChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {clabel.COMBO_SELECT}
                          </option>
                          {examList &&
                            examList.length > 0 &&
                            examList
                              .filter(
                                (element) =>
                                  element.isDeleted === false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {element.name}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedExam.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {clabel.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>
                      <div className="form-group col-md-3">
                        <label className="float-left">
                          Add Criteria
                        </label>

                        <select
                          className="form-control"
                          value={addCriteria}
                          onChange={(e) => setAddCriteria(e.target.value)}
                        >
                          <option value="NO">No</option>
                          <option value="YES">Yes</option>
                        </select>
                      </div>
                      {/* <div className="form-group col-md-3">
                        <label className="float-left">
                          {label.PostCriteria}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedPostCriteria"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onPostCriteriaChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {postcriterialisting &&
                            postcriterialisting.length > 0 &&
                            postcriterialisting
                              .filter(
                                (element) =>
                                  element.isDeleted == false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {element.name}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedPostCriteria.type", errors) ===
                          "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div> */}

                      {selectedAdvertiseNo && addCriteria === "YES" && (
                        <div className="form-group col-md-3">
                          <label className="float-left">
                            {label.PostCriteria}
                            <span className="errorText">*</span>
                          </label>
                          <Select
                            isMulti
                            name="selectedPostCriteria"
                            // ref={register({ required: true })}
                            value={selectedPostCriteria}
                            onChange={(selectedOptions) => {
                              handlePostCriteria(selectedOptions);
                            }}
                            options={postCriteriaOptions && postCriteriaOptions}
                          />

                          {/* {_.get("selectedPostCriteria.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {clabel.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )} */}
                        </div>
                      )}

                      {requestedData &&
                        requestedData.length > 0 &&
                        requestedData.map((item, index) => {
                          const filteredValue =
                            selectedPostCriteria &&
                            selectedPostCriteria.filter(
                              (element) => element.value == item.postCriteriaId
                            );
                          return (
                            <>
                              <div className="table table-bordered m-3 p-2">
                                <label className="post_criteria bold-text mb-2">
                                  Post Criteria:{filteredValue[0]?.label}
                                </label>
                                <div className="row ">
                                  <div className="col-md-3">
                                    <label className="float-left">
                                      {label.SelectCategory}
                                      <span className="errorText">*</span>
                                    </label>
                                    <select
                                      className="form-control"
                                      name={`selectedCategory[${index}]`}
                                      ref={register({ required: true })}
                                      onChange={(e) => {
                                        onCategoryChange(
                                          filteredValue[0].value,
                                          e.target.value,
                                          index
                                        );
                                      }}
                                    // value={selectedCategory}
                                    >
                                      <option key={0} value="">
                                        {clabel.COMBO_SELECT}
                                      </option>
                                      {adminCategoriesList &&
                                        adminCategoriesList.length > 0 &&
                                        adminCategoriesList.map(
                                          (element, index1) => (
                                            <option
                                              key={index1}
                                              value={element.name}
                                            >
                                              {element.name}
                                            </option>
                                          )
                                        )}
                                    </select>
                                  </div>
                                  <div className="col-md-6">
                                    <label className="float-left">
                                      {label.SelectSubCategory}
                                      <span className="errorText">*</span>
                                    </label>
                                    <Select
                                      closeMenuOnSelect={false}
                                      isMulti
                                      name={`selectedSubCategory[${index}]`}
                                      // ref={register({ required: true })}
                                      value={selectedSubCategory[index] || []}
                                      // selectedSubCategory[${innd}]
                                      onChange={(e) => {
                                        onSubCategoryChange(
                                          filteredValue[0].value,
                                          e,
                                          index
                                        );
                                      }}
                                      options={options && options}
                                    />
                                  </div>
                                </div>
                                <div className="row mb-2">
                                  <div className="col-md-6">
                                    {selectedSubCategory &&
                                      selectedSubCategory[index] &&
                                      selectedSubCategory[index].length > 0 && (
                                        <table>
                                          <thead>
                                            <tr>
                                              <th className="p-2 text-center">
                                                SubCategory
                                              </th>
                                              <th className="p-2 text-center">
                                                ReservedSeat
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {selectedSubCategory[index].map(
                                              (subItem, ind) => (
                                                <tr key={ind}>
                                                  <td>{subItem.label}</td>
                                                  <td>
                                                    <input
                                                      type="text"
                                                      pattern="^([0-9]|[1-9][0-9]{0,2}|1000)$"
                                                      name={`reservedSeat[${index}][${ind}]`}
                                                      className="form-control"
                                                      onChange={(e) => {
                                                        onReserveSeatChange(
                                                          filteredValue[0]
                                                            .value,
                                                          e.target.value,
                                                          subItem.label
                                                        );
                                                      }}
                                                    />
                                                  </td>
                                                </tr>
                                              )
                                            )}
                                          </tbody>
                                        </table>
                                      )}
                                  </div>
                                </div>

                                {item &&
                                  item.criteria &&
                                  item.criteria.length > 0 && (
                                    <div className="row">
                                      <div className="col-md-6">
                                        <table className="table">
                                          <thead>
                                            <tr>
                                              <th>Category</th>
                                              <th>SubCategory</th>
                                              <th>Reserved Seats</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {item.criteria.length > 0 &&
                                              item.criteria.map(
                                                (criteria, criteriaIndex) => (
                                                  <tr key={criteriaIndex}>
                                                    <td>{criteria.category}</td>
                                                    <td>
                                                      {criteria.subCategory}
                                                    </td>
                                                    <td>
                                                      {criteria.reservedSeats}
                                                    </td>
                                                  </tr>
                                                )
                                              )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  )}
                                <>
                                  <div className="row">
                                    <div className="col-md-3 d-flex">
                                      <input
                                        type="checkbox"
                                        id="experienceCheckbox"
                                        name={`experienceCheckbox[${index}]`}
                                        onChange={(event) =>
                                          onhandleexperiencecheckbox(
                                            filteredValue[0].value,
                                            event.target.checked,
                                            index
                                          )
                                        }
                                      />
                                      <label className="float-left ml-1">
                                        {label.Experience}
                                        {/* <span className="errorText">*</span> */}
                                      </label>
                                    </div>
                                  </div>
                                  {experienceCheckbox[index] == true && (
                                    <div className="row d-flex">
                                      <div className="col-md-3">
                                        <label className="float-left">
                                          {label.Designation}
                                          <span className="errorText">*</span>
                                        </label>
                                        <select
                                          className="form-control"
                                          name={`Destination[${index}]`}
                                          // ref={register({
                                          //   required: true,
                                          // })}
                                          onChange={(e) => {
                                            onDesignation(
                                              filteredValue[0].value,
                                              e.target.value,
                                              index
                                            );
                                          }}
                                        // value={selectedCategory}
                                        >
                                          <option key={0} value="">
                                            {clabel.COMBO_SELECT}
                                          </option>
                                          {getDesignation &&
                                            getDesignation.length > 0 &&
                                            getDesignation.map(
                                              (element, index) => (
                                                <option
                                                  key={index}
                                                  value={element.id}
                                                >
                                                  {element.label}
                                                </option>
                                              )
                                            )}
                                        </select>
                                        {/* {_.get(
                                                "Destination.type",
                                                errors
                                              ) === "required" && (
                                                <p className="errorText float-left">
                                                  {
                                                    clabel.MANDATORY_FIELD_MESSAGE
                                                  }
                                                </p>
                                              )} */}
                                      </div>
                                      <div className="col-md-3">
                                        <label className="float-left">
                                          {label.Jobnature}
                                          <span className="errorText">*</span>
                                        </label>
                                        <select
                                          className="form-control"
                                          name={`Jobnature[${index}]`}
                                          // ref={register({
                                          //   required: true,
                                          // })}
                                          onChange={(e) => {
                                            onJobNature(
                                              filteredValue[0].value,
                                              e.target.value,
                                              index
                                            );
                                          }}
                                        // value={selectedCategory}
                                        >
                                          <option key={0} value="">
                                            {clabel.COMBO_SELECT}
                                          </option>
                                          {getjobnature &&
                                            getjobnature.length > 0 &&
                                            getjobnature.map((element, index) => (
                                              <option
                                                key={index}
                                                value={element.id}
                                              >
                                                {element.label}
                                              </option>
                                            ))}
                                        </select>
                                        {/* {_.get(
                                                "Jobnature.type",
                                                errors
                                              ) === "required" && (
                                                <p className="errorText float-left">
                                                  {
                                                    clabel.MANDATORY_FIELD_MESSAGE
                                                  }
                                                </p>
                                              )} */}
                                      </div>
                                      <div className="col-md-3">
                                        <label className="float-left">
                                          {label.Appointmentnature}
                                          <span className="errorText">*</span>
                                        </label>
                                        <select
                                          className="form-control"
                                          name={`Appointmentnature[${index}]`}
                                          // ref={register({
                                          //   required: true,
                                          // })}
                                          onChange={(e) => {
                                            onAppointmentNature(
                                              filteredValue[0].value,
                                              e.target.value,
                                              index
                                            );
                                          }}
                                        // value={selectedCategory}
                                        >
                                          <option key={0} value="">
                                            {clabel.COMBO_SELECT}
                                          </option>
                                          {getappointmentNature &&
                                            getappointmentNature.length > 0 &&
                                            getappointmentNature.map(
                                              (element, index) => (
                                                <option
                                                  key={index}
                                                  value={element.id}
                                                >
                                                  {element.label}
                                                </option>
                                              )
                                            )}
                                        </select>
                                        {/* {_.get(
                                                "Appointmentnature.type",
                                                errors
                                              ) === "required" && (
                                                <p className="errorText float-left">
                                                  {
                                                    clabel.MANDATORY_FIELD_MESSAGE
                                                  }
                                                </p>
                                              )} */}
                                      </div>
                                    </div>
                                  )}
                                  {item.experience &&
                                    item.experience.data &&
                                    item.experience.data.length > 0 && (
                                      <div className="row">
                                        <div className="col">
                                          <table className="table">
                                            <thead>
                                              <tr>
                                                <th>{label.Designation}</th>
                                                <th> {label.Jobnature}</th>
                                                <th>{label.Appointmentnature}</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {item.experience.data.length > 0 &&
                                                item.experience.data.map(
                                                  (criteria, criteriaIndex) => {
                                                    const selectDesignation =
                                                      getDesignation.filter(
                                                        (ite) =>
                                                          criteria.designation ==
                                                          ite.id
                                                      );
                                                    const selectJob =
                                                      getjobnature.filter(
                                                        (ite) =>
                                                          criteria.jobNatureLookupId ==
                                                          ite.id
                                                      );
                                                    const selectappointment =
                                                      getappointmentNature.filter(
                                                        (ite) =>
                                                          criteria.typeEmploymentLookupId ==
                                                          ite.id
                                                      );
                                                    return (
                                                      <tr key={criteriaIndex}>
                                                        <td>
                                                          {
                                                            selectDesignation[0]
                                                              ?.label
                                                          }
                                                        </td>
                                                        <td>
                                                          {selectJob[0]?.label}
                                                        </td>
                                                        <td>
                                                          {
                                                            selectappointment[0]
                                                              ?.label
                                                          }
                                                        </td>
                                                      </tr>
                                                    );
                                                  }
                                                )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    )}
                                  <div className="row">
                                    <div className="col-md-3 mt-3">
                                      <input
                                        type="checkbox"
                                        id="qualificationCheckbox"
                                        name={`qualificationCheckbox[${index}]`}
                                        onChange={(event) =>
                                          onhandlequalificationcheckbox(
                                            filteredValue[0].value,
                                            event.target.checked,
                                            index
                                          )
                                        }
                                      />
                                      <label className="float-left ml-1">
                                        {label.Qualification}
                                        {/* <span className="errorText">*</span> */}
                                      </label>
                                    </div>
                                  </div>
                                  {qualificationCheckbox[index] == true && (
                                    <div className="row">
                                      <div className="col-md-3">
                                        <label className="float-left">
                                          {label.QualificationType}
                                          <span className="errorText">*</span>
                                        </label>
                                        <select
                                          className="form-control"
                                          name={`qualificationType[${index}]`}
                                          // ref={register({
                                          //   required: true,
                                          // })}
                                          onChange={(e) => {
                                            onQualificationType(
                                              filteredValue[0].value,
                                              e.target.value,
                                              index
                                            );
                                          }}
                                        // value={selectedCategory}
                                        >
                                          <option key={0} value="">
                                            {clabel.COMBO_SELECT}
                                          </option>
                                          {getqualificationtype &&
                                            getqualificationtype.length > 0 &&
                                            getqualificationtype.map(
                                              (element, index) => (
                                                <option
                                                  key={index}
                                                  value={
                                                    element.qualificationTypeCode
                                                  }
                                                >
                                                  {element.qualificationTypeCode}
                                                </option>
                                              )
                                            )}
                                        </select>
                                        {/* {_.get(
                                                "qualificationType.type",
                                                errors
                                              ) === "required" && (
                                                <p className="errorText float-left">
                                                  {
                                                    clabel.MANDATORY_FIELD_MESSAGE
                                                  }
                                                </p>
                                              )} */}
                                      </div>
                                      <div className="col-md-3">
                                        <label className="float-left">
                                          {label.QualificationName}
                                          <span className="errorText">*</span>
                                        </label>
                                        <select
                                          className="form-control"
                                          name={`qualifcationName[${index}]`}
                                          // ref={register({
                                          //   required: true,
                                          // })}
                                          onChange={(e) => {
                                            onQualificationName(
                                              filteredValue[0].value,
                                              e.target.value,
                                              index
                                            );
                                          }}
                                        // value={selectedCategory}
                                        >
                                          <option key={0} value="">
                                            {clabel.COMBO_SELECT}
                                          </option>
                                          {getqualificationName &&
                                            getqualificationName.length > 0 &&
                                            getqualificationName.map(
                                              (element, index) => (
                                                <option
                                                  key={index}
                                                  value={
                                                    element.qualificationNameCode
                                                  }
                                                >
                                                  {element.qualificationNameCode}
                                                </option>
                                              )
                                            )}
                                        </select>
                                        {/* {_.get(
                                                "qualifcationName.type",
                                                errors
                                              ) === "required" && (
                                                <p className="errorText float-left">
                                                  {
                                                    clabel.MANDATORY_FIELD_MESSAGE
                                                  }
                                                </p>
                                              )} */}
                                      </div>
                                    </div>
                                  )}
                                  {item &&
                                    item.qualification &&
                                    item.qualification.data &&
                                    item.qualification.data.length > 0 && (
                                      <div className="row">
                                        <div className="col-md-6">
                                          <table className="table">
                                            <thead>
                                              <tr>
                                                <th>{label.QualificationType}</th>
                                                <th>{label.QualificationName}</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {item.qualification.data.length >
                                                0 &&
                                                item.qualification.data.map(
                                                  (criteria, criteriaIndex) => {
                                                    return (
                                                      <tr key={criteriaIndex}>
                                                        <td>
                                                          {
                                                            criteria?.qualificationtypecode
                                                          }
                                                        </td>
                                                        <td>
                                                          {criteria?.qualificationnamecode
                                                            ? criteria?.qualificationnamecode
                                                            : "-"}
                                                        </td>
                                                      </tr>
                                                    );
                                                  }
                                                )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    )}
                                  <div className="row">
                                    <div className="col-md-3 mt-3">
                                      <input
                                        type="checkbox"
                                        id="dobCheckbox"
                                        name={`dobCheckbox[${index}]`}
                                        onChange={(event) =>
                                          onhandledobcheckbox(
                                            filteredValue[0].value,
                                            event.target.checked,
                                            index
                                          )
                                        }
                                      />
                                      <label className="float-left ml-1">
                                        {label.DOB}
                                        {/* <span className="errorText">*</span> */}
                                      </label>
                                    </div>
                                  </div>
                                  {dobCheckbox[index] == true && (
                                    <div className="row">
                                      <div className="col-md-3">
                                        <label className="float-left">
                                          {label.SelectOrder}
                                          <span className="errorText">*</span>
                                        </label>
                                        <select
                                          className="form-control"
                                          name={`selectedorder[${index}]`}
                                          // ref={register({ required: true })}
                                          onChange={(e) => {
                                            ondobOrder(
                                              filteredValue[0].value,
                                              e.target.value,
                                              index
                                            );
                                          }}
                                        // value={selectedCategory}
                                        >
                                          <option key={0} value="">
                                            {clabel.COMBO_SELECT}
                                          </option>
                                          {dobcheckedistrue &&
                                            dobcheckedistrue.length > 0 &&
                                            dobcheckedistrue.map(
                                              (element, index) => (
                                                <option
                                                  key={index}
                                                  value={element.name}
                                                >
                                                  {element.name}
                                                </option>
                                              )
                                            )}
                                        </select>
                                        {/* {_.get(
                                              "selectedorder.type",
                                              errors
                                            ) === "required" && (
                                              <p className="errorText float-left">
                                                {clabel.MANDATORY_FIELD_MESSAGE}
                                              </p>
                                            )} */}
                                      </div>
                                    </div>
                                  )}
                                </>
                              </div>
                            </>
                          );
                        })}
                      {flagArray &&
                        flagArray.length > 0 &&
                        flagArray.map((ele, index) => (
                          <div className="row pl-3 pr-3" key={index}>
                            <div className="col">
                              <input
                                type="checkbox"
                                disabled
                                checked={ele.flagStatus === true && true}
                                className="form-control"
                              />
                              <label className="ml-1">{ele.flag}</label>
                            </div>
                          </div>
                        ))}
                    </div>
                    <div className="row">
                      <div className="form-group col-md-6">
                        <button
                          type="reset"
                          className="btn btn-secondary mr-2"
                          onClick={() => onCancelButton()}
                        >
                          {clabel.BUTTON_CANCEL}
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          disabled={save}
                          onClick={() => onSubmit()}
                        >
                          {clabel.BUTTON_SAVE}
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary ml-2"
                          onClick={handleView}
                          disabled={!selectedExam}
                        >
                          View
                        </button>

                        {(session.roleName === "superadmin" ||
                          session.roleName === "secretary") &&
                          showUnlock[0]?.flag === "Recommendation Criteria" &&
                          typeof showUnlock[0]?.flagStatus === "boolean" && (
                            <button
                              type="button"
                              className={`ml-2 btn mr-2 ${showUnlock[0]?.flagStatus
                                ? "btn-lock-green"
                                : "btn-unlock-red"
                                }`}
                              disabled={lock}
                              onClick={() => {
                                handleLockUnlock(
                                  "recommendationCriteria",
                                  !showUnlock[0]?.flagStatus
                                );
                              }}
                              style={{
                                borderRadius: "0.60rem",
                              }}
                            >
                              {showUnlock[0]?.flagStatus
                                ? commonLabels.BUTTON_UNLOCK
                                : commonLabels.BUTTON_LOCK}
                            </button>
                          )}
                        <div className="row mt-4">
                          <div className="col-md-12">

                            {showTable &&
                              recommendationSeatMatrixData?.map((post, index) => {

                                const postInfo = postcriterialisting?.find(
                                  (item) => Number(item.id) === Number(post.postCriteriaId)
                                );

                                const postName = postInfo?.name || "";

                                const totalSeats =
                                  post.criteria?.reduce(
                                    (sum, item) => sum + Number(item.reservedSeats || 0),
                                    0
                                  ) || 0;

                                return (
                                  <div key={post.postCriteriaId || index} className="mb-5">

                                    {/* POST NAME */}
                                    <h5 className="font-weight-bold mb-3">
                                      Post : {postName}
                                    </h5>

                                    <table
                                      className="table table-bordered text-center "
                                      style={{ width: "530px" }}
                                    >
                                      <thead className="thead-light">
                                        <tr>
                                          <th style={{ width: "35%" }}>
                                            {label.Category}
                                          </th>

                                          <th style={{ width: "35%" }}>
                                            {label.SubCategory}
                                          </th>

                                          <th style={{ width: "30%" }}>
                                            {label.reservedSeat}
                                          </th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        {post.criteria?.map((item, i) => (
                                          <tr key={i}>
                                            <td>{item.category}</td>

                                            <td>{item.subCategory}</td>

                                            <td>{item.reservedSeats}</td>
                                          </tr>
                                        ))}

                                        {/* TOTAL */}
                                        <tr>
                                          <td
                                            colSpan={2}
                                            className="text-centre font-weight-bold"
                                          >
                                            {label.totalSeats}
                                          </td>

                                          <td className="font-weight-bold">
                                            {totalSeats}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>

                                  </div>
                                );
                              })}

                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div
            className={
              stepName === "unapproved"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="unapproved"
            role="tabpanel"
            aria-labelledby="unapproved-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                {getrecommendationCriterialist &&
                  getrecommendationCriterialist.entityApprovalDtoList &&
                  getrecommendationCriterialist.entityApprovalDtoList.length >
                  0 ? (
                  <>
                    <table className="table table-bordered">
                      <thead className="thead-light">
                        <tr>
                          {unapprovalEntityHeader &&
                            unapprovalEntityHeader.map((itm, ind) => (
                              <th
                                key={ind}
                                className={`${itm === "Sr.No." || itm === "Action"
                                  ? "text-center"
                                  : ""
                                  }`}
                              >
                                {itm}
                              </th>
                            ))}
                        </tr>
                      </thead>
                      <tbody>
                        {getrecommendationCriterialist &&
                          getrecommendationCriterialist.entityApprovalDtoList &&
                          getrecommendationCriterialist.entityApprovalDtoList
                            .length > 0 &&
                          getrecommendationCriterialist.entityApprovalDtoList.map(
                            (ele, index) => {
                              return (
                                <tr key={index}>
                                  <td className="w-5 text-center">
                                    {tableCounter_unapproval++}
                                  </td>
                                  <td className=" word-break">
                                    {ele.entityApprovalAction.actionLabel}
                                  </td>
                                  <td className="width-5">
                                    {ele.entityApprovalAction.level == 1
                                      ? label.APPROVAL_LEVEL_1_PENDING
                                      : ""}
                                    {ele.entityApprovalAction.level == 2
                                      ? label.APPROVAL_LEVEL_2_PENDING
                                      : ""}
                                    {ele.entityApprovalAction.level == 3
                                      ? label.APPROVAL_LEVEL_3_PENDING
                                      : ""}
                                  </td>
                                  <td className=" word-break width-10">
                                    {ele.entityApprovalAction.updatedAt
                                      ? dayjs(
                                        ele.entityApprovalAction.updatedAt
                                      ).format("DD/MM/YYYY h:mm A")
                                      : ""}
                                  </td>

                                  <td className="w-10 word-break  width-20">
                                    {ele.entityApprovalAction.entityApprovalDto
                                      .detail &&
                                      ele.entityApprovalAction.entityApprovalDto
                                        .detail[0] &&
                                      ele.entityApprovalAction.entityApprovalDto
                                        .detail[0].exam &&
                                      ele.entityApprovalAction.entityApprovalDto
                                        .detail[0].exam.name}
                                    <br />
                                    {ele.entityApprovalAction.entityApprovalDto
                                      .detail &&
                                      ele.entityApprovalAction.entityApprovalDto
                                        .detail[0] &&
                                      ele.entityApprovalAction.entityApprovalDto
                                        .detail[0].exam &&
                                      ele.entityApprovalAction.entityApprovalDto
                                        .detail[0].exam.nameDvng}
                                  </td>

                                  <td>
                                    {ele.entityApprovalAction.entityApprovalDto.entityMaster.name.replace(
                                      "_",
                                      " "
                                    )}
                                  </td>

                                  <td className="word-break">
                                    {
                                      ele.entityApprovalAction.entityApprovalDto
                                        .approvalTypeLabel
                                    }
                                  </td>
                                  <td className=" word-break">
                                    {
                                      ele.entityApprovalAction.entityApprovalDto
                                        .approvalByUser.firstName
                                    }{" "}
                                    {
                                      ele.entityApprovalAction.entityApprovalDto
                                        .approvalByUser.lastName
                                    }
                                  </td>

                                  <td className="word-break">
                                    {ele.entityApprovalAction.comments}
                                  </td>
                                  <td className="text-center word-break width-12">
                                    {(session.roleName == "superadmin" ||
                                      session.roleName == "desk officer") && (
                                        <button
                                          type="button"
                                          className="pull-right btn btn-outline-primary btn-sm custom-button"
                                          onClick={() => {
                                            handleApprovalUser(ele);
                                          }}
                                        >
                                          {clabel.REVIEW}
                                        </button>
                                      )}
                                  </td>
                                </tr>
                              );
                            }
                          )}
                      </tbody>
                    </table>
                    <TablePagination
                      paginationFor="un_cutoff_list"
                      rowPerPage={rowPerPage}
                      setListCurrentPage={setListCurrentPage}
                      totalCount={
                        getrecommendationCriterialist.totalNoOfRecords
                      }
                    />
                  </>
                ) : (
                  <div className="text-center">
                    <font className="text-danger">{clabel.NO_DATA_FOUND}</font>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div
            className={
              stepName === "recommendationCriteriaList"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="recommendationCriteriaList"
            role="tabpanel"
            aria-labelledby="list-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <form name="importForm" encType="multipart/form-data">
                  <div className="form-group ">
                    <div className="row">
                      <div className="form-group col-md-3">
                        <label className="float-left">
                          {commonLabels.selectYear}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedYear1"
                          value={selectedYear1}
                          // ref={register({ required: true })}
                          onChange={(e) => {
                            onSelectYear(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {yearList &&
                            yearList.length > 0 &&
                            yearList.map((element, index) => (
                              <option>{element}</option>
                              // <option key={index} value={element.id}>
                              //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                              // </option>
                            ))}
                        </select>
                        {_.get("selectedYear1.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>
                      <div className="form-group col-md-3">
                        <label className="float-left">
                          {commonLabels.SelectAdvertNo}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedAdvertiseNo1"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onAdvertisementChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {getMainsAdvertisement &&
                            getMainsAdvertisement.length > 0 &&
                            getMainsAdvertisement
                              .filter(
                                (element) =>
                                  element.isDeleted == false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedAdvertiseNo1.type", errors) ===
                          "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                      </div>
                      <div className="form-group col-md-3">
                        <label className="float-left">
                          {label.SelectExam}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedExam1"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onExamChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {clabel.COMBO_SELECT}
                          </option>
                          {examList &&
                            examList.length > 0 &&
                            examList
                              .filter(
                                (element) =>
                                  element.isDeleted === false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {element.name}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedExam1.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {clabel.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-md-6">
                        <button
                          type="reset"
                          className="btn btn-secondary mr-2"
                          onClick={() => onCancelButton()}
                        >
                          {clabel.BUTTON_CANCEL}
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary mr-2"
                          disabled={viewDisable}
                          onClick={() => onViewButton("recoVacantPosition")}
                        >
                          {clabel.BUTTON_VIEW}
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary mr-2"
                          disabled={
                            printFlag ||
                            !listRecommendationReports.vacantPosition
                          }
                          onClick={() => {
                            downloadPdf();
                          }}
                        >
                          {commonLabels.BUTTON_PRINT}
                        </button>
                        {listRecommendationReports &&
                          listRecommendationReports.recommendationReportType ===
                          "recoVacantPosition" &&
                          listRecommendationReports.vacantPosition &&
                          listRecommendationReports.vacantPosition.length > 0 &&
                          showEdit == true && (
                            <button
                              type="button"
                              className="btn btn-primary mr-2"
                              onClick={() => {
                                onEditButton();
                              }}
                            >
                              {commonLabels.BUTTON_EDIT}
                            </button>
                          )}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            {listRecommendationReports &&
              listRecommendationReports.recommendationReportType ===
              "recoVacantPosition" &&
              listRecommendationReports.vacantPosition &&
              listRecommendationReports.vacantPosition.length > 0 && (
                <div
                  ref={pdfRef}
                  id="qualifyingCandidatesList"
                  className="container mt-4"
                >
                  {/* {listRecommendationReports.vacantPosition.map(
                    (item, index) => (
                      <div className="row justify-content-center" key={index}>
                        <div className="col-md-12 ">
                          <table
                            className="table table-bordered text-center bold-label no-page-break mb-5"
                            cellPadding={0.5}
                          >
                            <thead className="bold-label">
                              <tr>
                                <th>Post Criteria Code</th>
                                <th className="w-80">
                                  <label className="bold-label ">
                                    {label.category}
                                  </label>
                                 
                                </th>
                                <th>{label.SubCategory}</th>
                                <th className="w-100px">
                                  {label.reservedSeat}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{item.code}</td>
                                <td colSpan={3}>
                                  <table
                                    className="table table-border bold-label"
                                    cellPadding={0.5}
                                  >
                                    <tbody>
                                      {item.data.map(
                                        (codeCategory, codeCategoryIndex) => (
                                          <tr key={codeCategoryIndex}>
                                            <td>{codeCategory.categoryName}</td>
                                            <td>
                                              <table
                                                className="table table-borderless bold-label"
                                                cellPadding={0.5}
                                              >
                                                <tbody>
                                                  {codeCategory.data.map(
                                                    (
                                                      subcategory,
                                                      subCategoryIndex
                                                    ) => (
                                                      <tr
                                                        key={subCategoryIndex}
                                                      >
                                                        <td>
                                                          {
                                                            subcategory.subCategoryName
                                                          }
                                                        </td>
                                                        <td className="text-center">
                                                          {subcategory.posts}
                                                        </td>
                                                      </tr>
                                                    )
                                                  )}
                                                </tbody>
                                              </table>
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    )
                  )} */}
                  {listRecommendationReports?.vacantPosition?.map((post, index) => {
                    const reservedSeatsTotal = post.data.reduce((sum, category) => {
                      return (
                        sum +
                        category.data.reduce(
                          (subSum, sub) => subSum + Number(sub.posts || 0),
                          0
                        )
                      );
                    }, 0);

                    const multiple = Number(post.reservedMultiple || 0);

                    return (
                      <div key={index} className="mb-5">

                        {/* Post Name */}
                        <h6 className="mb-2 font-weight-bold">
                          Post : {post.code}
                        </h6>

                        <table className="table table-bordered text-center">
                          <thead className="thead-light">
                            <tr>
                              <th>Category</th>
                              <th>Sub-Category</th>
                              <th>Reserved Seats</th>
                              {/* <th>Multiple</th>
                              <th>Total Seats</th> */}
                            </tr>
                          </thead>

                          <tbody>
                            {post.data?.map((category, catIndex) => (
                              <React.Fragment key={catIndex}>
                                {category.data?.map((sub, subIndex) => {
                                  const reservedSeats = Number(sub.posts || 0);

                                  return (
                                    <tr key={subIndex}>

                                      {/* Category once for all its subcategories */}
                                      {subIndex === 0 && (
                                        <td
                                          rowSpan={category.data.length}
                                          className="align-middle"
                                        >
                                          {category.categoryName}
                                        </td>
                                      )}

                                      <td>{sub.subCategoryName}</td>

                                      <td>{reservedSeats}</td>

                                      {/* <td>
                                        {multiple > 0 ? `X ${multiple}` : ""}
                                      </td>

                                      <td>
                                        {multiple > 0
                                          ? reservedSeats * multiple
                                          : reservedSeats}
                                      </td> */}
                                    </tr>
                                  );
                                })}
                              </React.Fragment>
                            ))}

                            {/* Total Row */}
                            {/* <tr>
                              <td></td>
                              <td></td>

                              <td className="font-weight-bold">
                                Total Seats = {reservedSeatsTotal}
                              </td>

                              <td></td>

                              <td className="font-weight-bold">
                                Total Seats ={" "}
                                {multiple > 0
                                  ? reservedSeatsTotal * multiple
                                  : reservedSeatsTotal}
                              </td>
                            </tr> */}
                          </tbody>
                        </table>
                      </div>
                    );
                  })}
                </div>
              )}
          </div>
        </div>

        {approvalEntityModal && (
          <ApprovalRecommendationCriteriaEntity
            showModal={approvalEntityModal}
            setShowModal={setApprovalEntityModal}
            setSelectedApprovalEntity={selectedApprovalEntity}
          />
        )}
        {showUpdateModal && (
          <UpdateRecommendationCriteria
            showUpdateModal={showUpdateModal}
            setShowUpdateModal={setShowUpdateModal}
            setUpdatedValue={updatedValue}
            selectedExam={selectedExamlist}
          />
        )}
      </div>
    </div>
  );
};

export default RecommendationCriteria;
